// import React from 'react';
// import './Hero.css';

// export default function Hero({ onFormOpen }) {
//   return (
//     <section className="hero" id="hero">
//       <div className="hero__bg">
//         <img
//           src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1600&q=80"
//           alt="Gym Arena"
//           className="hero__bg-img"
//         />
//         <div className="hero__overlay" />
//       </div>

//       <div className="hero__content container">
//         <p className="section-label">Welcome to</p>
//         <h1 className="hero__title">
//           Gym<br />
//           <span>Arena</span>
//         </h1>
//         <p className="hero__subtitle">
//           8,500 Sq. Ft. of world-class fitness — powered by the industry's finest equipment.
//           Your transformation starts here.
//         </p>
//         <div className="hero__actions">
//           <button className="hero__btn-primary" onClick={onFormOpen}>
//             Enquire Now
//           </button>
//           <a href="#gallery" className="hero__btn-secondary">
//             Explore Gym
//           </a>
//         </div>

//         <div className="hero__stats">
//           <div className="hero__stat">
//             <span className="hero__stat-num">8,500</span>
//             <span className="hero__stat-label">Sq. Ft. Area</span>
//           </div>
//           <div className="hero__stat-divider" />
//           <div className="hero__stat">
//             <span className="hero__stat-num">7+</span>
//             <span className="hero__stat-label">Premium Brands</span>
//           </div>
//           <div className="hero__stat-divider" />
//           <div className="hero__stat">
//             <span className="hero__stat-num">100%</span>
//             <span className="hero__stat-label">Committed</span>
//           </div>
//         </div>
//       </div>

//       <div className="hero__scroll-hint">
//         <span />
//       </div>
//     </section>
//   );
// }

import React from 'react';
import './Hero.css';
import { motion } from 'framer-motion';

export default function Hero({ onFormOpen }) {

  // Parent animation (stagger effect)
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  // Individual item animation
  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <section className="hero" id="hero">
      
      {/* Background */}
      <div className="hero__bg">
        <img
          src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1600&q=80"
          alt="Gym Arena"
          className="hero__bg-img"
        />
        <div className="hero__overlay" />
      </div>

      {/* Content */}
      <motion.div
        className="hero__content container"
        variants={container}
        initial="hidden"
        animate="show"   // ✅ important fix (NOT whileInView)
      >

        <motion.p className="section-label" variants={item}>
          Welcome to
        </motion.p>

        <motion.h1 className="hero__title" variants={item}>
          Gym<br />
          <span>Arenaa</span>
        </motion.h1>

        <motion.p className="hero__subtitle" variants={item}>
          8,500 Sq. Ft. of world-class fitness — powered by the industry's finest equipment.
          Your transformation starts here.
        </motion.p>

        <motion.div className="hero__actions" variants={item}>
          <button className="hero__btn-primary" onClick={onFormOpen}>
            Enquire Now
          </button>
          <a href="#gallery" className="hero__btn-secondary">
            Explore Gym
          </a>
        </motion.div>

        <motion.div className="hero__stats" variants={item}>
          
          <div className="hero__stat">
            <span className="hero__stat-num">8,500</span>
            <span className="hero__stat-label">Sq. Ft. Area</span>
          </div>

          <div className="hero__stat-divider" />

          <div className="hero__stat">
            <span className="hero__stat-num">7+</span>
            <span className="hero__stat-label">Premium Brands</span>
          </div>

          <div className="hero__stat-divider" />

          <div className="hero__stat">
            <span className="hero__stat-num">100%</span>
            <span className="hero__stat-label">Committed</span>
          </div>

        </motion.div>

      </motion.div>

      {/* Scroll hint */}
      <div className="hero__scroll-hint">
        <span />
      </div>

    </section>
  );
}